import React from 'react';
import Button from 'react-bootstrap/Button';
import './PrintButton.css';

function PrintButton() {
  const print = () => {
    window.print();
  };

  const isMobile = /Android|iPhone/i.test(navigator.userAgent);

  return (!isMobile && (
    <div id="print-button" className="mx-auto my-3">
      <Button
        className="w-100 no-print"
        variant="secondary"
        onClick={print}
      >
        Imprimir
      </Button>
    </div>
  ));
}

export default PrintButton;
